import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import EhashEmailPreferences from '@/components/Settings/EhashEmailPreferences';
import AuthenticatedEmailPreferences from '@/components/Settings/AuthenticatedEmailPreferences';

const settingsRoute = getRouteApi('/_app/settings');

interface EmailSettingsSearch {
  ehash?: string;
  unsubscribed?: string;
}

export const Route = createFileRoute('/_app/settings/email')({
  validateSearch: (search: Record<string, unknown>): EmailSettingsSearch => ({
    ehash: typeof search.ehash === 'string' ? search.ehash : undefined,
    unsubscribed:
      typeof search.unsubscribed === 'string' ? search.unsubscribed : undefined,
  }),
  component: EmailPreferencesPage,
});

function EmailPreferencesPage() {
  const { ehash, unsubscribed } = Route.useSearch();
  const navigate = Route.useNavigate();

  // An emailed ehash stands in for a session: show that mailbox's settings
  // even when signed out (or signed into a different account).
  if (ehash) {
    return (
      <EhashEmailPreferences
        ehash={ehash}
        unsubscribed={unsubscribed}
        onUnsubscribedHandled={() => navigate({ search: { ehash }, replace: true })}
      />
    );
  }

  return <AuthenticatedEmailPreferencesPage />;
}

function AuthenticatedEmailPreferencesPage() {
  const settings = settingsRoute.useLoaderData();

  return (
    <AuthenticatedEmailPreferences
      initialPreferences={settings.emailPreferences}
      formKey={settings.user.formKey}
    />
  );
}
